import get from "lodash/get"

/**
 * Функция, создающая функцию, для сравнения пропов и их вложенных свойств
 * Возврвращает true, если что-то не совпадает
 *
 * Создана для применения в первом аргументе withPropsOnChange
 *
 * @param paths
 * @returns {function(*=, *=): *}
 */
export default paths => (props, nextProps) =>
  paths.some(path => get(props, path) !== get(nextProps, path))
